import { render } from "./App.vue?vue&type=template&id=437464a0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=437464a0&lang=css"
script.render = render

export default script